exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "table a.badge {\n  color: #fff; }\n\ntable th {\n  font-size: 80%; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/ContractsModule/ContractItemAvailabilityDialogComponent/contract-item-availability.dialog.component.scss
// module id = ../../../../../src/ContractsModule/ContractItemAvailabilityDialogComponent/contract-item-availability.dialog.component.scss
// module chunks = main